__turbopack_context__.v({
  "StarRatingError": "StarRating-module-scss-module__fCrHZG__StarRatingError",
});
